/***
 * @                  江城子 . 程序员之歌
 * @
 * @              十年生死两茫茫，写程序，到天亮。
 * @                  千行代码，Bug何处藏。
 * @              纵使上线又怎样，朝令改，夕断肠。
 * @
 * @              领导每天新想法，天天改，日日忙。
 * @                  相顾无言，惟有泪千行。
 * @              每晚灯火阑珊处，夜难寐，加班狂。
 * @
 * @
 * @Author: your name
 * @Date: 2022-02-22 14:17:06
 * @LastEditTime: 2022-03-09 09:11:00
 * @LastEditors: your name
 * @Description: 
 * @FilePath: /dangdaihui/src/utils/wxConfig.js
 ***/

import wx from 'weixin-js-sdk' // 引入微信SDK
import { getRequest } from './api'
const sha256 = require("js-sha256").sha256;

function randomString(length) {
  let result = '';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
 
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
 
  return result;
}
export function initConfig () {
  let url = window.location.href.split('#')[0]

  const now = Date.now(); // 获取当前时间的毫秒数
  const timestampSeconds = Math.floor(now / 1000); // 转换为秒
  const Str =randomString(6)
  const sign = sha256('action=all&&appId=11&&name=cmjt&&nonceStr='+Str+'&&platform=wx&&timestamp='+timestampSeconds+'&&url='+encodeURI(url)+'&&salt=jdzxxx2')

  console.log(333,encodeURI(url));
  
  getRequest("/getJsConfig?url="+encodeURI(url)+'&name=cmjt&action=all',
    {'X-APP-ID':11,
      'X-Platform':'wx',
      'X-Nonce-Str':Str,
      'X-TIMESTAMP':timestampSeconds,
      'X-SIGNATURE':sign

  }).then((res) => {
  
   var  wxdata= JSON.parse(JSON.stringify(res.data.data))
    console.log(wxdata)
    const theurl = new URL(window.location.href);
    const params = new URLSearchParams(theurl.search);
    let id = params.get('id'); // "John"
    
    if (id) {
    }else{
      id=0
    }
    
    var thelist=[{title:'好彩头',desc:'金彩云给您拜年啦！'}
      ,{title:'好彩头——明呈地产给您拜年啦！',desc:'明呈地产给您拜年啦！'}
      ,{title:'好彩头——正福隆壹墅大门给您拜年啦！',desc:'正福隆壹墅大门寇红军给您拜年啦！'}
      ,{title:'好彩头——金华清和园给您拜年啦！',desc:'金华清和园供应链有限公司给您拜年啦！'}
      ,{title:'好彩头——中国铁塔公司给您拜年啦！',desc:'中国铁塔金华市分公司给您拜年啦！'}
      ,{title:'好彩头——金华天开电子材料有限公司给您拜年啦！',desc:'浙江金华天开电子材料有限公司给您拜年啦！'}
      ,{title:'好彩头——金华老年开放大学给您拜年啦！',desc:'金华老年开放大学给您拜年啦！'}
      ,{title:'好彩头——万鑫源给您拜年啦！',desc:'万鑫源给您拜年啦！'}
      ,{title:'好彩头——柚香谷给您拜年啦！',desc:'柚香谷宋柚汁给您拜年啦！'}
      ,{title:'好彩头——金义租赁给您拜年啦！',desc:'浙江金义融资租赁有限公司给您拜年啦！'}
      ,{title:'好彩头——金华市荣光学校给您拜年啦！',desc:'金华市荣光学校给您拜年啦！'}
      ,{title:'好彩头——滨江城投·和品给您拜年啦！',desc:'滨江城投·和品给您拜年啦！'}
      ,{title:'好彩头——滨江城投·和品给您拜年啦！',desc:'滨江城投·和品给您拜年啦！'}
      ,{title:'好彩头——国网（金华）综合能源服务有限公司给您拜年啦！',desc:'国网（金华）综合能源服务有限公司给您拜年啦！'}
      ,{title:'好彩头——中国人寿金华分公司给您拜年啦！',desc:'中国人寿金华分公司给您拜年啦！'}
      ,{title:'好彩头——金华职业技术大学附属医院给您拜年啦！',desc:'金华职业技术大学附属医院给您拜年啦！'}
      ,{title:'好彩头——浙江明洁生活服务有限公司给您拜年啦！',desc:'浙江明洁生活服务有限公司给您拜年啦！'}
      ,{title:'好彩头——浙江婺剧艺术研究院给您拜年啦！',desc:'浙江婺剧艺术研究院给您拜年啦！'}
      ,{title:'好彩头——金华华数广电网络有限公司给您拜年啦！',desc:'金华华数广电网络有限公司给您拜年啦！'}
    ]
    const share = {
      title: thelist[id].title,
      imgUrl: 'https://zthd.jcy.jinhua.com.cn/hct/share.jpg',
      link: wxdata.url, // 分享链接
      desc:thelist[id].desc
    }

    console.log(share);
    // console.log(typeof String(wxdata.timestamp));
    
    wx.config({
      debug: false,
      appId: wxdata.appId,
      timestamp: String(wxdata.timestamp),
      nonceStr: String(wxdata.nonceStr),
      signature: wxdata.signature,
      jsApiList: wxdata.jsApiList
    })

    wx.error(function (res) {
      console.log('验证失败返回的信息:', res)
    })

    wx.checkJsApi({
      jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareAppMessage', 'onMenuShareTimeline'],
      success: function (res) {
        console.log('🚀 ~ file: wxConfig.js ~ line 47 ~ res', res)
        // 以键值对的形式返回，可用的api值true，不可用为false
        // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
      }
    })



   wx.ready(function () {

      // 分享给朋友
      wx.updateAppMessageShareData({
        title: share.title, // 分享标题
        desc: share.desc, // 分享描述
        link: share.link, // 分享链接
        imgUrl: share.imgUrl, // 分享图标
        desc:share.desc,
        success: function () {
          // window.alert('已分享给好友');
          console.log('分享内容', share)

        }
      })

      // 分享到朋友圈
      wx.updateTimelineShareData({
        title: share.title, // 分享标题
        link: share.link, // 分享链接
        imgUrl: share.imgUrl, // 分享图标
        desc:share.desc,
        success: function () {
          // window.alert('已分享到朋友圈');
          console.log('分享内容', share)

        },
      })
      wx.onMenuShareTimeline({
        title: share.title, // 分享标题
        link: share.link, // 分享链接
        imgUrl: share.imgUrl, // 分享图标
        desc:share.desc,
        success: function () {
          // window.alert('已分享到朋友圈');
          console.log('分享内容', share)

        },
      })
      wx.onMenuShareAppMessage({
        title: share.title, // 分享标题
        desc: share.desc, // 分享描述
        link: share.link, // 分享链接
        imgUrl: share.imgUrl, // 分享图标
        desc:share.desc,
        success: function () {
          // window.alert('已分享给好友');
          console.log('分享内容', share)

        }
      });
      
      // wx.onMenuShareTimeline({
      //   title: share.title, // 分享标题
      //   link: share.link, // 分享链接
      //   imgUrl: share.imgUrl, // 分享图标
      //   success: function () {
      //     // 用户点击了分享后执行的回调函数
      //     console.log('分享内容', share)

      //   }
      // })

      // wx.onMenuShareAppMessage({
      //   title: share.title, // 分享标题
      //   link: share.link, // 分享链接
      //   imgUrl: share.imgUrl, // 分享图标
      //   type: '', // 分享类型,music、video或link，不填默认为link
      //   dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
      //   success: function () {
      //     // 用户点击了分享后执行的回调函数
      //     console.log('分享内容', share)
      //   }
      // })

    })
  })
}